var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout_Master',[_c('main',{staticClass:"content"},[_c('div',{staticClass:"section-header separator-bottom"},[_c('Header_Large',[_vm._v(_vm._s(_vm.$t("general.favorites")))])],1),_c('Favorites_PostList')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }